export default __webpack_public_path__ + "static/media/uploading.2914e872.svg";